// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { usePermission } from 'features/auth/usePermission';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //
// Items without a `permission` field (dashboard, utilities, support) are always
// visible. Items with one are hidden unless the user has that code; a group left
// with zero visible children is hidden entirely instead of rendering an empty title.

function filterByPermission(item, hasPermission) {
  if (item.type !== 'group') return item;

  const children = item.children?.filter((child) => !child.permission || hasPermission(child.permission));
  if (!children || children.length === 0) return null;

  return { ...item, children };
}

export default function Navigation() {
  const hasPermission = usePermission();

  const navGroups = menuItem.items
    .map((item) => filterByPermission(item, hasPermission))
    .filter(Boolean)
    .map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;
        default:
          return (
            <Typography key={item.id} variant="h6" sx={{ color: 'error.main', textAlign: 'center' }}>
              Fix - Navigation Group
            </Typography>
          );
      }
    });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
